$(document).ready(function () {
  var isDown = false;
  var startX, scrollLeft, isDragging;
  var $activeGrid = null;

  // ----- Desktop Drag -----
  $(document).on('mousedown', 'ul.custom-product-grid', function (e) {
    isDown = true;
    isDragging = false;
    $activeGrid = $(this);
    startX = e.pageX - $activeGrid.offset().left;
    scrollLeft = $activeGrid.scrollLeft();
    $activeGrid.addClass('is-dragging');
    e.preventDefault();
  });

  $(document).on('mouseup', function () {
    if (isDown && $activeGrid) {
      isDown = false;
      $activeGrid.removeClass('is-dragging');
      $activeGrid = null;
    }
  });

  $(document).on('mousemove', 'ul.custom-product-grid', function (e) {
    if (!isDown || !$activeGrid) return;

    var x = e.pageX - $activeGrid.offset().left;
    var walk = (x - startX) * 1.5;
    $activeGrid.scrollLeft(scrollLeft - walk);
    isDragging = true;
  });

  // Prevent click during drag
  $(document).on('click', 'ul.custom-product-grid', function (e) {
    if (isDragging) {
      e.preventDefault();
      e.stopPropagation();
    }
    isDragging = false;
  });
});
